import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=2c8f2f48&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=2c8f2f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f2f48",
  null
  
)

export default component.exports